import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '~/shadcn/components/ui/Dialog';
import { Button } from '~/shadcn/components/ui/Button';
import { AlertTriangle } from 'lucide-react';

/**
 * Warning modal that displays when user tries to prep a pallet with multiple lots
 * @param {object} props
 * @param {boolean} props.open - Whether the modal is open
 * @param {function} props.onOpenChange - Function to handle modal open/close state
 * @param {string} props.lotId - The lot ID that the user tried to prep
 * @param {string} props.palletId - The pallet ID that contains multiple lots
 * @returns {JSX.Element}
 */
function MultipleLotWarningModal({ open, onOpenChange, lotId, palletId }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md text-center">
                <DialogHeader className="flex flex-col items-center space-y-3">
                    <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                        <AlertTriangle className="h-8 w-8 text-yellow-600" />
                    </div>
                    <DialogTitle className="text-xl font-semibold text-gray-900">Cannot Prep Lot</DialogTitle>
                    <DialogDescription className="sr-only">Multiple lots warning for prep action</DialogDescription>
                </DialogHeader>
                <div className="space-y-4">
                    <p className="text-gray-600">
                        To prep lot <span className="font-semibold text-gray-900">{lotId}</span>, it must first be moved
                        to a new pallet. This is required because multiple lots are currently on pallet{' '}
                        <span className="font-semibold text-gray-900">{palletId}</span>.
                    </p>
                    <p className="text-gray-500">
                        Please separate the lots manually before proceeding with the prep action.
                    </p>
                </div>
                <DialogFooter className="flex justify-center">
                    <Button
                        onClick={() => onOpenChange(false)}
                        className="bg-gray-600 hover:bg-gray-700 text-white px-8"
                    >
                        Understood
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default MultipleLotWarningModal;
